import styled from "styled-components";
import { Paragraph } from "../../atoms/Typography/Typography.styles";

interface CardSquareProps {
  colorScheme?: string,
  withBackground?: boolean
}

export const CardSquare = styled.a<CardSquareProps>`
  width: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;

  ${Paragraph} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'}!important;
  }
`

export const CardSquareImage = styled.div`
  width: 100%;
  aspect-ratio: 4 / 4;
  border-radius: ${({ theme }) => theme.rem(8)};
  overflow: hidden;
  position: relative;
  margin-bottom: ${({ theme }) => theme.rem(16)};
  
  img {
    object-fit: cover;
    object-position: center;
    transition: transform 0.3s ease-in-out;
    transform: scale(1);
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    &:hover {
      img {
        transform: scale(1.1);  
      }
    }
  `)}
`